document.addEventListener("hofmannApi:ready", () => {
    document.querySelectorAll('input[data-api-autocomplete]').forEach(inputField => {
        const searchContext = inputField.dataset['apiAutocomplete'];
        if (searchContext !== 'place' && searchContext !== 'search') { // Allow only specific search context
            return;
        }

        inputField.acResultCount = 0;
        let backspaceTrap = false,
            enterTrap = false;

        inputField.addEventListener('keydown', (e) => {
            // check backspace
            if (e.keyCode === 8 || e.keyCode === 46) {
                backspaceTrap = true;
                setTimeout(() => backspaceTrap = false, 2000);
            }

            // Check enter
            else if (e.keyCode === 13) {
                enterTrap = true;
                useFirstResultIfNecessary()
            }

            // tab
            else if (e.keyCode === 9) {
                useFirstResultIfNecessary()
            } else {
                inputField.acSelectedDetails = null;
            }
        });

        // Handle submit if no selection was made
        const form = inputField.closest('form');
        form.addEventListener('submit', (e) => {
            useFirstResultIfNecessary()
        });

        const positionList = (ac) => {
            if (!ac.list || !ac.input) return;
            const wrapper = ac.list.closest(".ac-results-wrapper");

            if (wrapper) {
                ac.list.style.top = 'auto';

                const position =
                  ac.input.getBoundingClientRect().bottom + wrapper.getBoundingClientRect().height >
                  (window.innerHeight || document.documentElement.clientHeight);
                if (position) {
                    wrapper.style.top = 'auto';
                    wrapper.style.bottom = ac.input.offsetHeight + 8 + "px";
                } else {
                    wrapper.style.bottom = 'auto';
                    wrapper.style.top = ac.input.offsetHeight + 8 + "px";
                }
            }
        };

        const limit = 10;
        const ac = new autoComplete({
            selector: () => inputField,
            diacritics: true,
            searchEngine: (query, record) => {
                return record // pass-thru result
            },
            data: {
                src: async (query) => {
                    inputField.acResultCount = 0;
                    let returnData = [];
                    try {
                        const country = typeof apiCountryCode !== 'undefined' ? apiCountryCode : 'de';

                        let response;
                        if (searchContext === 'place') {
                            response = await hofmannApiLoader.request.get(`${hofmannApiLoader.hostURI}geo-data/search/${country}/${query}?limit=${limit}`).set('accept', 'json');
                        } else {
                            const endpoint = HofmannApi.getOption('endpoint', 'hofmann_de');
                            response = await hofmannApiLoader.request.get(`${hofmannApiLoader.hostURI}vacancies/${endpoint}/suggest?search=${inputField.value}&limit=${limit}`).set('accept', 'json');
                        }
                        const data = response.body;

                        if (data) {
                            if (data.err) {
                                console.error("API Error:", data.err);
                            } else if (searchContext === 'place' && Array.isArray(data.data)) {
                                inputField.acResultCount = data.data.length;
                                inputField.acResult = data.data.map(item => ({
                                    label: `${item.postcode} ${item.locality}`,
                                    details: item
                                }));
                                returnData = inputField.acResult;
                            } else if (searchContext === 'search' && data.suggestions) {
                                const _r = [];
                                for (const [category, items] of Object.entries(data.suggestions)) {
                                    if (items) {
                                        items.forEach(item => {
                                            _r.push({ label: `${item}`, details: item });
                                        });
                                    }
                                }
                                inputField.acResultCount = _r.length;
                                inputField.acResult = _r;
                                returnData = _r;
                            }
                        }
                    } catch (error) {
                        console.error("API Error:", error);
                        returnData = [];
                    }

                    return returnData;
                },
                keys: ["label"]
            },
            debounce: 300,
            resultsList: {
                maxResults: limit,
                tabSelect: true,
                element: (list, data) => {
                    let wrapper = list.closest('.ac-results-wrapper');
                    if (!wrapper) {
                        const wrapper = document.createElement("div");
                        wrapper.setAttribute("class", "ac-results-wrapper");

                        list.parentNode.insertBefore(wrapper, list);
                        wrapper.appendChild(list);
                    }

                    if (!backspaceTrap && data.results.length === 1 && data.query.length > 2) {
                        ac.input.value = data.results[0].value.label;
                        setTimeout(function(){
                            ac.close();
                            handlePlaceSelection(data.results[0].value);
                        }, 0);
                    }

                    if (enterTrap) {
                        setTimeout(() => {
                            enterTrap = false;
                            ac.close();
                        }, 0);
                    }
                }
            },
            resultItem: {
                highlight: true
            },
            events: {
                input: {
                    selection: (event) => {
                        handlePlaceSelection(event.detail.selection.value);
                    },
                    open() {
                        const wrapper = ac.list.closest(".ac-results-wrapper");
                        if (wrapper) {
                            wrapper.removeAttribute("hidden");
                        }
                        positionList(ac);
                        window.addEventListener("scroll", () => positionList(ac), true);
                        window.addEventListener("resize", () => positionList(ac));
                    },
                    close() {
                        const wrapper = ac.list.closest(".ac-results-wrapper");
                        if (wrapper) {
                            wrapper.setAttribute('hidden', '');
                        }
                        window.removeEventListener("scroll", () => positionList(ac), true);
                        window.removeEventListener("resize", () => positionList(ac));
                    },
                },
            }
        });
        ac.input.addEventListener('focus', () => {
            if (inputField.acResultCount) {
                ac.open();
            }
        });
        ac.input.addEventListener('keydown', (e) => {
            // Allow press enter for submit on empty value
            if (e.keyCode === 13 && ac.input.value === '') {
                handlePlaceSelection(false)
            }
        });
        ac.wrapper.setAttribute('data-api-autocomplete-wrapper', '1')

        function handlePlaceSelection(selection) {
            if (selection) {
                inputField.value = selection.label;
                inputField.acSelectedDetails = selection.details;
            } else {
                inputField.value = '';
                inputField.acSelectedDetails = null;
            }

            const form = inputField.closest('form');
            const submitBtn = form.querySelector('[type="submit"]');

            if (submitBtn) {
                submitBtn.click();
            } else {
                form.submit();
            }

            ac.close();
        }

        function useFirstResultIfNecessary() {
            if (searchContext === 'place') { // only on location inputs
                if (!inputField.acSelectedDetails && inputField.value !== '') {
                    if (ac && inputField.acResultCount > 0 && inputField.acResult.length > 0) {
                        handlePlaceSelection(inputField.acResult[0]);
                    }
                }
            } else {
                handlePlaceSelection({
                    label: inputField.value,
                    acSelectedDetails: inputField.value,
                });
            }
        }
    });
})